import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';
ComponentUtil.loader(
  !!document.querySelector(Hooks.ModalRoot),
  () => import('./Modal'),
  (Modal) => {
    ComponentUtil.binder(Hooks.ModalRoot, Modal);
  },
);
